import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=9a122e1a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a122e1a')) {
      api.createRecord('9a122e1a', component.options)
    } else {
      api.reload('9a122e1a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=9a122e1a&", function () {
      api.rerender('9a122e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s41RxwjEZx2w/JS/comp/ErrorMessage.vue"
export default component.exports